export default "__VITE_ASSET__C12FTRf6__"